import { accordionsReducer as _accordionsReducer } from "./accordions";

export const accordionsReducer = {
  accordions: _accordionsReducer,
};

export * from "./accordions";
